module.exports = __webpack_public_path__ + "img/bananer-mountain.a479b34f.png";